import { ref } from 'vue'
import { useLocale } from '@/composables/useLocale'
import { fetchDocCategories } from '@/api/docs'
import type { DocCategorySummary } from '@/types/docs'

export function useDocCategories() {
  const { currentLocale } = useLocale()

  const categories = ref<DocCategorySummary[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetch(): Promise<void> {
    loading.value = true
    error.value = null
    try {
      categories.value = await fetchDocCategories(currentLocale.value)
    } catch {
      error.value = 'docs.hub.error'
    } finally {
      loading.value = false
    }
  }

  return { categories, loading, error, fetch }
}
